import { isBrowserSupportedNotifications } from '../../utils/notifications'

export class WebPushNotificationsClient {
    private isPending = false
    private workerPath = ''
    private serverKey = ''

    constructor(workerPath: string, serverKey: string) {
        this.workerPath = workerPath
        this.serverKey = serverKey
    }

    private requestPermission() {
        return new Promise((resolve, reject) => {
            const permissionResult = Notification.requestPermission((result) => {
                // Поддержка устаревшей версии с функцией обратного вызова.
                resolve(result)
            })

            permissionResult?.then(resolve, reject)
        }).then((permissionResult) => {
            if (permissionResult !== 'granted') {
                throw new Error('Permission not granted.')
            }
        })
    }

    private registerWorker() {
        return new Promise<ServiceWorkerRegistration>((res, rej) => {
            navigator.serviceWorker
                .register(this.workerPath, {
                    scope: '/',
                })
                .then((registration) => {
                    if (registration.active) {
                        res(registration)
                    } else {
                        console.warn('WebPush Service Worker not yet active, waiting...')
                        navigator.serviceWorker.ready.then((registration) => {
                            console.info('WebPush Service Worker is ready')
                            res(registration)
                        })
                    }
                }, rej)
        })
    }

    private async subscribeClientToPush() {
        const registration = await this.registerWorker()

        const subscribeOptions = {
            userVisibleOnly: true,
            applicationServerKey: this.serverKey,
        }

        const pushSubscription = await registration.pushManager.subscribe(subscribeOptions)

        return pushSubscription
    }

    public async subscribe(callback: (subscription: PushSubscription) => void) {
        if (this.isPending) {
            return
        }

        if (!isBrowserSupportedNotifications()) {
            console.error('Браузер не поддерживает пуш-уведомления.')
        }

        if (!('serviceWorker' in navigator)) {
            console.error('Браузер не поддерживает сервис-воркеры.')
            return
        }

        if (!('PushManager' in window)) {
            console.error('Браузер не поддерживает push-уведомления.')
            return
        }

        try {
            this.isPending = true

            if (Notification.permission === 'default') {
                await this.requestPermission()
            }

            const subscription = await this.subscribeClientToPush()

            callback(subscription)
        } catch (error) {
            console.error(error)
        } finally {
            this.isPending = false
        }
    }
}
